var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"work-wrapper"},[_vm._l((_vm.iframeList),function(iframe){return [_c('navigation-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.name === iframe.code),expression:"$route.name === iframe.code"}],key:iframe.code,attrs:{"url":iframe.url,"code":iframe.code}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }